module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-md navbar-dark bg-dark fixed-top"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "d-inline-block align-middle",
    attrs: {
      "src": "src/assets/logo.png",
      "alt": "",
      "height": "30"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "h1 navbar-brand mb-0"
  }, [_vm._v("Lernin Games")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Lernin games")]), _vm._v(" "), _c('list-games')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-687f8beb","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 30
// module chunks = 0